"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTableRowOverrides = function (_a) {
    var palette = _a.palette;
    return ({
        root: {
            "&$selected, &$selected:hover": {
                backgroundColor: palette.action.hover,
            },
        },
    });
};
//# sourceMappingURL=MuiTableRow.js.map